import { NewMap } from '@synergy/maps';
import i18next from "i18next";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGlobalFilterContext } from "../../../../contexts/GlobalFilterProvider";
import { RegisterDetailView } from "../../../Pages/RegisterDetailView";
import Theme from "../../../../styles/Theme/Theme";
import Spinner from "../../Atomics/Spinner";
import useFetch from "../../../../server/useFetch";
import { containerMiddlewareAdEPorto } from "../../../../server/constants.api";
import { REACT_APP_MAPS_API_KEY } from "../../../../utils/config/envConfig";

// Define the MapsComponent function component
export const MapsComponent = ({ headerheight, BTN, BTE, MT, AT, BTN_IP }) => {
  // Define states and contexts
  const { t } = useTranslation();
  const [pois, setPois] = useState([]);
  const [mapConfigurations, setMapConfigurations] = useState(null);
  const [isMapLoading, setIsMapLoading] = useState(false);
  const { entityToFetch, subEntityToFetch, filterContent, isToApplyFilters, setIsToApplyFilters, classes } = useGlobalFilterContext();

  const {
    data: resourceMapItemsData,
    refetch: refetchResourceMapItems,
    isFetching: isFetchingResourceMapItems,
  } = useFetch('map/items', 'getResourceMapItems', {
    id: filterContent?.id,
    classes: filterContent?.classes?.join(), //Para enviar mais que uma enviar com ; (ex. Office;Lab)
    layer: 'Resource',//Incidents ou Services
    tenant: filterContent?.tenant,
  }, false, null, containerMiddlewareAdEPorto);

  useEffect(() => {
    const copyConfigurations = getDefaultMapConfigurations(t);
    const configurationsCopy = {
      ...copyConfigurations,
      lat: Number(subEntityToFetch?.cordinates?.latitude ?? entityToFetch?.cordinates?.latitude),
      lng: Number(subEntityToFetch?.cordinates?.longitude ?? entityToFetch?.cordinates?.longitude),
      zoom: entityToFetch?.zoom ?? 12
    };
    setMapConfigurations(configurationsCopy);
  }, []);

  useEffect(() => {
    if (isToApplyFilters) {
      if (!classes?.find(x => x.options?.length > 0)) {
        setPois([]);
      } else {
        refetchResourceMapItems();
        setIsMapLoading(true);
      }
      setIsToApplyFilters(false);
    }
  }, [isToApplyFilters]);

  useEffect(() => {
    if ((subEntityToFetch || entityToFetch) && isMapLoading &&
      !isFetchingResourceMapItems) {
      const copyConfigurations = getDefaultMapConfigurations(t);
      const configurationsCopy = {
        ...copyConfigurations,
        lat: Number(subEntityToFetch?.cordinates?.latitude ?? entityToFetch?.cordinates?.latitude),
        lng: Number(subEntityToFetch?.cordinates?.longitude ?? entityToFetch?.cordinates?.longitude),
        zoom: entityToFetch?.zoom ?? 12
      };

      setMapConfigurations(configurationsCopy);
      // setMapPoisWithTranslation();
      setIsToApplyFilters(false);
      setIsMapLoading(false);
    }
  }, [isFetchingResourceMapItems]);

  // Fetch map configurations data based on language change
  useEffect(() => {
    try {
      if ((subEntityToFetch || entityToFetch)) {
        const copyConfigurations = getDefaultMapConfigurations(t);
        const configurationsCopy = {
          ...copyConfigurations,
          lat: Number(subEntityToFetch?.cordinates?.latitude ?? entityToFetch?.cordinates?.latitude),
          lng: Number(subEntityToFetch?.cordinates?.longitude ?? entityToFetch?.cordinates?.longitude),
          zoom: entityToFetch?.zoom ?? 12
        };
        setMapConfigurations(configurationsCopy);
        // setMapPoisWithTranslation();
      }
    } catch (error) {
      console.error('(MapComponent page) Error in useEffect refetching map configuration Data:', error);
      //reportError(error); // Send error report to backend
    }

  }, [i18next.resolvedLanguage]);

  // Handle POIs filtering and update
  useEffect(() => {
    try {
      const activeVoltageLevels = [];
      if (BTN) activeVoltageLevels.push('BTN');
      if (BTE) activeVoltageLevels.push('BTE');
      if (MT) activeVoltageLevels.push('MT');
      if (AT) activeVoltageLevels.push('AT');
      if (BTN_IP) activeVoltageLevels.push('BTN-IP');

      const newPois = resourceMapItemsData?.data?.filter(item => activeVoltageLevels.includes(item['voltageLevel'])) || [];
      setPois(newPois);
    } catch (error) {
      console.error('(MapComponent page) Error in useEffect setting POIs to show:', error);
    }
  }, [BTN, BTE, MT, AT, BTN_IP, resourceMapItemsData]);

  // Define states for selected POI and side panel
  const [selectedPOI, setSelectedPOI] = useState(null);
  const panel = document.getElementById('openSidePanel');

  // Handle marker click event
  const handleMarkerClick = (markerId) => {
    try {
      const clickedMarker = pois.find(marker => marker.id === markerId);
      setSelectedPOI(clickedMarker);
      panel.classList.add('is-open');
      // logger.info('User clicked Marker');
    } catch (error) {
      // logger.error('Error in handling Marker Click');
      console.error('(MapComponent page) Error in handling Marker Click:', error);
      //reportError(error); // Send error report to backend
    }
  };

  // Handle closing of side panel
  const handleCloseSidePanel = () => {
    try {
      panel.classList.remove('is-open');
      setSelectedPOI(null);
      // logger.info('User Closed Side Panel');
    } catch (error) {
      // logger.error('Error in handling close side panel');
      console.error('(MapComponent page) Error in handling close side panel:', error);
      //reportError(error); // Send error report to backend
    }
  };

  console.log('pois ', pois);
  return (
    <MapWrapper $marginTop={headerheight}>
      {mapConfigurations ? (
        <>
          {!isMapLoading ?
            <NewMap configurations={mapConfigurations} pois={pois} onMarkerClick={handleMarkerClick} apiKey={REACT_APP_MAPS_API_KEY} />
            : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}><Spinner stroke="green-4" size='72px' /></div>
          }
          <SidePanel id='openSidePanel' headerheight={headerheight} className="">
            <div id="handleOutsideClick" onClick={handleCloseSidePanel} className="click-area"></div>
            <div className="panel">
              {selectedPOI ?
                <RegisterDetailView className='panel'
                  selectedPOI={selectedPOI}
                  onClose={handleCloseSidePanel}
                />
                : null}

            </div>
          </SidePanel>
        </>)
        : <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}> <Spinner stroke="green-4" /></div>}
    </MapWrapper>
  )
};

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const MapWrapper = styled.div`
    height: ${props => (props.$marginTop ? 'calc(100% - ' + props.$marginTop + ')' : '100%')};
    margin-top: ${props => (props.$marginTop ? props.$marginTop : '0')};
    padding: 0;
    width: -webkit-fill-available;
`;
const SidePanel = styled.div`
    width: 0;
    position: absolute;
    top: ${props => (props.headerheight ?? null)};
    right: 0;
    bottom: 0;
    display: flex;
    z-index: 100;
    height: 100%;

    &.is-open{
        width: 100%;

        .click-area{
            min-width: 65%;
            min-height: 100%;
        }
        .panel{       
            height: 100%;
            background-color: ${Theme.color['neutral-1']};
            width: 35%;   
            overflow-y: scroll; 
            transition: width 0.3s ease; 
            width: 100%;
        }
    }  
`;
//#endregion


function getDefaultMapConfigurations(t) {
  return {
    "heading": 0,
    "hide": [
      "attraction",
      "sports_complex",
      "place_of_worship",
      "business",
      "government",
      "medical",
      "park",
      "school"
    ],
    "mapId": "15fb961c1d0a757",
    "showGTFSRealTime": false,
    "showPOIS": true,
    "showTraffic": false,
    "showTransit": false,
    "showPolygon": false,
    "showEvents": false,
    "styles": "default",
    "tilt": 0,
    "zoom": 12,
    "hrefLink": "/home/register/registerDetail/",
    "poiType": "pois-color-by-family",
    "showLegend": true,
    "legendArray": [{
      label: t('Buildings'),
      color: 'color1-medium',
      typoligies: [{
        label: t('School'),
        icon: "School",
      }, {
        label: t('Social'),
        icon: "SocialHousing",
      }, {
        label: t('Cultural Spaces'),
        icon: "CulturalSpaces",
      }, {
        label: t('Pavilion'), //Pavilhão
        icon: "SportIndoor",
      }, {
        label: t('Comercial'),
        icon: "Euro",
      }, {
        label: t('Civil Protection'),
        icon: "CivilProtection",
      }, {
        label: t('Sports'),
        icon: "Gym",
      }, {
        label: t('Others'),
        icon: "Marker",
      }, {
        label: t('Administrative'),
        icon: "Clipboard",
      },
      {
        label: t('Storage'),
        icon: "Storage",
      },
      {
        label: t('Social Housing'),
        icon: "SocialHousing",
      },
      {
        label: t('Health'),
        icon: "Health",
      },
      {
        label: t('events'),
        icon: "Cone",
      }
      ]
    },
    {
      label: t('Infrastructures'),
      color: 'color2-medium',
      typoligies: [{
        label: t('Parking Lot'),
        icon: "ParkingLot",
      },
      {
        label: t('Graveyard'),
        icon: "Graveyard",
      },
      {
        label: t('Advertising Panels'),
        icon: "AdvertisingPanels",
      },
      // {
      //   label: 'Waste Water Treatment',
      //   icon: "WasteWaterTreatment",
      // },
      {
        label: t('Sanitary waste water collection'),
        icon: "SanitaryWasteWaterCollection",
      },
      // {
      //   label: 'Recycled Waste Collection',
      //   icon: "SolidWaste",
      // },
      {
        label: t('Domestic Waste Collection'),
        icon: "HouseholdWasteCollection",
      },
      {
        label: t('Energy Production'),
        icon: "EnergyProduction",
      },
      {
        label: t('Tunnel'),
        icon: "Tunnel",
      },
      // {
      //   label: 'Irrigation System',
      //   icon: "",
      // },
      {
        label: t('Public Space'),
        icon: "PublicSpaces",
      },
      {
        label: t('Monument'),
        icon: "Monument",
      },
      {
        label: t('Distribution Network'),
        icon: "DistributionNetwork",
      },
      // {
      //   label: 'Distribution Transformer Station',
      //   icon: "",
      // },
      // {
      //   label: 'Electricity Meter',
      //   icon: "ElectricityMeter",
      // },
      // {
      //   label: 'Gas Meter',
      //   icon: "GasMeter",
      // },
      {
        label: t('Electric Vehicle Charging Station'),
        icon: "ElectricStation",
      },
      {
        label: t('Water Supply'),
        icon: "WaterDrop",
      },
      // {
      //   label: 'Water Treatment',
      //   icon: "WasteWaterTreatment",
      // },
      {
        label: t('Traffic Light'),
        icon: "TrafficLight",
      },
      {
        label: t('Road Segment'),
        icon: "Road",
      }
      ]
    },
    {
      label: t('Street Lighting'),
      color: 'color3-medium',
      typoligies: [{
        label: t('Street Lighting'),
        icon: "StreetLight",
      }]
    },
      // { label: 'Provisional', color: 'color5-medium' },
    ],
    "legendDetail": true,
    "hideEventsInfo": false,
    "circleRadius": null
  };
};